<template>
  <div style="height: calc(100vh - 27px); overflow-y: auto; overflow-x: hidden">
    <router-view />
    <b-loading v-model="isLoading" :can-cancel="false" />
  </div>
</template>

<script>
export default {
  name: 'IndexAdmin',
  computed: {
    isLoading() {
      return this.$store.getters.isLoading;
    },
  },
  mounted() {
    this.$store.dispatch('WHEN_ACCESSING_ADMIN_PANEL');
    this.$store.commit('SET_ADMIN_ACTIVE', true);
  },
  beforeDestroy() {
    this.$store.commit('SET_ADMIN_ACTIVE', false);
  },
};
</script>
